import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import styles from "./create-app-page-adapter-selection-layout.styles";
import CreateAppPageAdaptersFilter from "../adapters-filter/create-app-page-adapters-filters";
import CreateAppPageAdaptersList from "../adapters-list/create-app-page-adapters-list";
import securityService from "../../../../../../../../core/services/securityService/securityService";

interface SelectionLayoutProps {
    type: string;
    onClose: Function;
    handleSelection: Function;
    adapterList: Array<any>;
}
export type filtersType = {
    id: string;
    category: string;
};
const CreateAppPageAdapterSelectionLayout: React.FunctionComponent<SelectionLayoutProps> = ({
    type,
    onClose,
    handleSelection,
    adapterList
}) => {
    const defaultCategory = securityService.isFabricSolution() && type === "target" ? "SQL2Fabric-X" : "all";
    const [filters, setFilters] = useState<{ id: string; category: string }>(
        { id: "", category: defaultCategory }
    );
    const [selectedView, setSelectedView] = useState<"list" | "grid">("grid");
    const [filteredAdapters, setFilteredAdapters] = useState(adapterList);
    const [isAscendingSort, setIsAscendingSort] = useState<boolean>(true);

    const getCategoryFilter = adapter => {
        if (filters.category === "all") return true;
        if (filters.category === "new") {
            return adapter.newlyReleased;
        }
        return adapter.category?.toLowerCase() === filters.category?.toLowerCase();
    };

    useEffect(() => {
        if (filters.id || filters.category !== "all") {
            const filteredData = adapterList.filter(adapter => {
                const searchFilter = adapter.id.toLowerCase().includes(filters.id.toLowerCase());
                const categoryFilter = getCategoryFilter(adapter);
                return searchFilter && categoryFilter;
            });
            setFilteredAdapters(filteredData);
        } else {
            setFilteredAdapters(adapterList);
        }
    }, [filters]);

    return (
        <Grid container sx={styles.wrapper}>
            <Grid item sx={styles.headerContainer}>
                <CreateAppPageAdaptersFilter
                    selectedView={selectedView}
                    setSelectedView={setSelectedView}
                    type={type}
                    filters={filters}
                    setFilters={setFilters}
                    onClose={onClose}
                    isAscendingSort={isAscendingSort}
                    setIsAscendingSort={setIsAscendingSort}
                />
            </Grid>
            <Grid item sx={styles.childContainer}>
                <CreateAppPageAdaptersList
                    selectedView={selectedView}
                    adapters={filteredAdapters}
                    handleSelection={handleSelection}
                    type={type}
                    isAscendingSort={isAscendingSort}
                    filters={filters}
                />
            </Grid>
        </Grid>
    );
};

export default CreateAppPageAdapterSelectionLayout;
